import styled from "styled-components";

const Heading = styled.span`
  font-weight: bold !important;
`;

export default Heading;
